function buocDanhMuc() {
  return [
    {
      target: "body",
      placement: "center",
      title: "Bước 1 · Danh mục",
      content:
        'Trang này chỉ quản lý danh mục Hình thức thanh toán dùng lại trong form thu mua — Loại bơ KHÔNG nằm ở đây (dễ nhầm vì tên trang chung chung), mà ở trang riêng "Loại bơ & Giá".',
    },
    {
      target: "#tour-quan-ly-danh-muc-nut-them",
      title: "Bước 2 · Thêm mục mới",
      content: "Bấm để thêm một hình thức thanh toán mới, dùng lại trong form thu mua.",
      placement: "bottom",
    },
    {
      target: "#tour-quan-ly-danh-muc-danh-sach",
      title: "Bước 3 · Sửa/Xoá ngay tại chỗ",
      content:
        "Mỗi dòng có nút Sửa/Xoá riêng — sửa xong bấm Lưu là áp dụng ngay, không cần form riêng.",
      placement: "top",
    },
  ];
}

export default buocDanhMuc;
